import { io } from "socket.io-client";
import {
  // attemptReconnect,
  connectionEstablished,
  connectionLost,
  errorOccurred,
  // resetReconnectAttempts,
  setOrgUsers,
} from "../websocketSlice";
import { toast } from "react-toastify";

let socket = null;

export const getSocket = () => socket;

// Connect to Socket.io
export const connectSocket = (data, dispatch) => {
  if (socket && data?.token) {
    console.warn("⚠️ Socket.io already connected.");
    return socket;
  }

  // console.log(data, "This is data for the user");

  socket = io(data?.url, {
    transports: ["websocket"], // Use WebSocket
    auth: { token: data?.token, deviceId: data?.deviceId }, // Send token in handshake
  });
toast.info("WebSocket connection initiated.");
  // console.log(socket, "This is socket");

  socket.connect();

  // On successful connection
  socket.on("connection", () => {
    console.log("✅ Socket.io Connected");
    dispatch(connectionEstablished());
    // dispatch(resetReconnectAttempts());
  });

  socket.on("success", (data) => {
    dispatch(setOrgUsers(data || {}));
  });

  // Handle connection errors
  socket.on("connect_error", (error) => {
    console.error("❌ Socket.io Connection Error:", error);
    dispatch(
      errorOccurred({ message: error.message || "Unknown Socket.io Error" })
    );
  });

  // Handle disconnection
  socket.on("disconnect", (reason) => {
    console.warn("⚠️ Socket.io Disconnected:", reason);
    dispatch(connectionLost({ reason }));
    // dispatch(attemptReconnect());
    socket = null;
  });

  return socket;
};

// Disconnect from Socket.io
export const disconnectSocket = (dispatch) => {
  if (socket) {
    socket.disconnect();
    socket = null;
    dispatch(connectionLost());
    console.log("❌ Socket.io Manually Disconnected");
  }
};
